import * as React from 'react';
import { ForwardedRef, forwardRef } from 'react';
import { IMaskedInputProps } from '@cian/ui-kit';

import { Input } from '../Input';

type TPhoneProps = Partial<Omit<IMaskedInputProps, 'onChange'>> & {
  onChange?(value: string): void;
};

/** Display `+7 999 123 45 67`, unmasked value `79991234567`. */
export const phoneMask = '+{7} 000 000 00 00';

export const PhoneInput = forwardRef((props: TPhoneProps, ref?: ForwardedRef<HTMLInputElement>) => {
  return <Input ref={ref} mask={phoneMask} lazy {...props} />;
});

PhoneInput.displayName = 'PhoneInput';
